import {selectTaskManagement} from '../../../taskManagement/selectors'

const getMenuStatusFilterState = (state) => selectTaskManagement(state).statusFilter

export const getMenuStatusFilter = (state) => getMenuStatusFilterState(state).filter


// WEBPACK FOOTER //
// ./web/js/workflowStatus/components/statusFilter/selectors.js